// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "invitation".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "invitation" table (1:1 with a DB row, on the wire). */
export const invitationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    email: z.string(),
    role: z.string().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    phone: z.string().nullable(),
    phoneCountry: z.string().nullable(),
    country: z.string().nullable(),
    status: z.string(),
    expiresAt: z.string().datetime(),
    inviterId: z.string(),
});
//# sourceMappingURL=invitation.js.map